/*
  h26-cart-set.js: the "You built your own set!" card inside UpCart's drawer (Amir Oct 20, Build your own, option C).
  The 4 Shopify automatic discounts (2 = 3%, 3 = 15%, 4 = 21%, 5+ = 24%) apply anywhere on the site to the 7 everyday
  2026 oils bought one-time, so once the cart holds 2 or more of them the drawer says so: the %, the saving, the next
  step, and "Add more" (to the builder on the Harvest 2026 page). Config: window.OO_H26_SET, from
  snippets/h26-cart-line.liquid (same file that draws the pre-order line; rendered once from layout/theme.liquid).

  Numbers: the saving is Shopify's own when the cart carries this discount (line allocations whose title starts with
  C.title); before the discounts exist it is the tier math. If another discount (a customer's code) is on those bottles
  instead, the card stays hidden: that code is the better deal and the card would be wrong.
  UpCart draws its drawer in an open shadow root on #upCart; the card goes right before .upcart-products-section.
  Events: set_card_view (once per page), set_card_add_more.
*/
(function () {
  'use strict';
  var C = window.OO_H26_SET;
  if (!C || window.__ooH26Set) return;
  window.__ooH26Set = true;
  var ids = {}; (C.pids || []).forEach(function (i) { ids[String(i)] = true; });
  var CLS = 'oo-h26-set', state = null, timer = null, seen = false;

  function track(n, d, el) { try { if (window.OOH26 && window.OOH26.track) window.OOH26.track(n, d || {}, el); } catch (e) {} }
  function pct(n) { var p = 0; C.tiers.forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }
  function next(n) { for (var i = 0; i < C.tiers.length; i++) if (C.tiers[i][0] > n) return C.tiers[i]; return null; }
  function money(cents) {
    var s = C.sample || '', v = Math.abs(Math.round(cents) / 100), euro = /1\.234,56/.test(s);
    var parts = v.toFixed(2).split('.'), int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, euro ? '.' : ',');
    var num = euro ? int + ',' + parts[1] : int + '.' + parts[1];
    return s ? s.replace(euro ? '1.234,56' : '1,234.56', num) : num;
  }
  function fill(t, m) { return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function root() { var h = document.getElementById('upCart'); return h && h.shadowRoot; }

  function read(cart) {
    var n = 0, full = 0, ours = 0, other = 0, units = [];
    (cart.items || []).forEach(function (l) {
      if (!ids[String(l.product_id)] || l.selling_plan_allocation) return;
      n += l.quantity; full += l.original_line_price != null ? l.original_line_price : l.price * l.quantity;
      units.push([l.original_price != null ? l.original_price : l.price, l.quantity]);
      (l.line_level_discount_allocations || []).forEach(function (a) {
        var t = (a.discount_application && a.discount_application.title) || '';
        if (C.title && t.indexOf(C.title) === 0) ours += a.amount; else other += a.amount;
      });
    });
    var p = pct(n), floorSum = 0;
    units.forEach(function (u) { floorSum += u[1] * Math.floor(u[0] * p / 100 + 1e-9); }); // rounded down per bottle, like Shopify
    var saved = ours || floorSum; // Shopify's own numbers when its discount is on the cart
    return { n: n, p: p, full: full, saved: saved, hide: n < 2 || (other > 0 && !ours) };
  }
  function style(r) {
    if (r.getElementById('oo-h26-set-css')) return;
    var st = document.createElement('style'); st.id = 'oo-h26-set-css';
    st.textContent = '.' + CLS + '{margin:12px 16px 4px;padding:12px 14px 12px 44px;position:relative;background:#eef3ea;border:1px solid #cfdcc6;border-radius:8px;color:#1c1d1d;font-size:13.5px;line-height:1.45;animation:ooH26SetIn .35s cubic-bezier(.2,1.35,.4,1)}'
      + '.' + CLS + '::before{content:"";position:absolute;left:14px;top:13px;width:20px;height:20px;border-radius:50%;background:#3f6b3a url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'%3E%3Cpath d=\'M4 8.4l2.5 2.4L12 5.3\' fill=\'none\' stroke=\'%23fff\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/15px no-repeat}'
      + '.' + CLS + ' b{display:block;font-size:15px;font-weight:600;margin-bottom:2px}'
      + '.' + CLS + ' .l{color:#3f6b3a;font-weight:600}.' + CLS + ' .n{color:#a26b25}'
      + '.' + CLS + ' .fs{display:block;margin-top:6px;font-size:12px;color:#6b6b66}'
      + '.' + CLS + ' a{display:inline-block;margin-top:6px;color:#1c1d1d;font-weight:600;text-decoration:underline;text-underline-offset:3px;cursor:pointer}'
      + '@keyframes ooH26SetIn{from{opacity:0;transform:translateY(-6px) scale(.97)}to{opacity:1;transform:none}}'
      + '@media (prefers-reduced-motion:reduce){.' + CLS + '{animation:none}}';
    r.appendChild(st);
  }
  function render() {
    var r = root(); if (!r) return;
    var old = r.querySelector('.' + CLS), anchor = r.querySelector('.upcart-products-section');
    if (!state || state.hide || !anchor) { if (old) old.remove(); return; }
    var nx = next(state.n), freeNow = C.freeCents && state.full - state.saved >= C.freeCents;
    // "and free shipping" only when the next tier is 3 bottles (ships free in every market with free shipping, checked Oct 20) and it doesn't already
    var nudge = !nx ? C.txt.best : fill(!freeNow && C.freeCents && nx[0] === 3 ? C.txt.nextFree : C.txt.next, { k: nx[0] - state.n, p: nx[1] });
    var key = [state.n, state.p, state.saved, freeNow ? 1 : 0].join('|');
    if (old && old.getAttribute('data-k') === key && old.nextElementSibling === anchor) return;
    style(r);
    var el = document.createElement('div');
    el.className = CLS; el.setAttribute('data-k', key); el.setAttribute('role', 'status');
    el.setAttribute('data-asset-id', 'h26-cart-set'); el.setAttribute('data-placement', 'upcart-drawer');
    el.innerHTML = '<b>' + esc(C.txt.built) + '</b><span class="l">' + esc(fill(C.txt.line, { n: state.n, p: state.p, amt: money(state.saved) }) + (freeNow ? ' · ' + C.txt.free : '')) + '.</span> '
      + '<span class="n">' + esc(nudge) + '</span>' + (nx ? '<br><a data-oo-set-more>' + esc(C.txt.more) + ' &rarr;</a>' : '')
      // Oct 23 (Amir): US carts that read "ships free" / "and free shipping" also say Alaska and Hawaii are excluded
      + (C.txt.fsNote && (freeNow || (nx && nudge === fill(C.txt.nextFree, { k: nx[0] - state.n, p: nx[1] }))) ? '<small class="fs">' + esc(C.txt.fsNote) + '</small>' : '');
    if (old) old.remove();
    anchor.parentNode.insertBefore(el, anchor);
    var more = el.querySelector('[data-oo-set-more]');
    if (more) more.addEventListener('click', function (e) {
      e.preventDefault(); track('set_card_add_more', { bottles: state.n }, el);
      var sec = document.getElementById('h26-lp-taste');
      if (sec) { try { window.upcartCloseCart && window.upcartCloseCart(); } catch (x) {} setTimeout(function () { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250); }
      else location.href = C.lp;
    });
    if (!seen) { seen = true; track('set_card_view', { bottles: state.n, tier: state.p }, el); }
  }
  function soon() { clearTimeout(timer); timer = setTimeout(render, 80); }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { state = read(c || {}); render(); }).catch(function () {});
  }
  ['cart-opened', 'cart-updated', 'cart-loaded', 'added-to-cart', 'item-removed'].forEach(function (n) {
    window.addEventListener('aftersell-upcart:public-events:' + n, function () { setTimeout(refresh, 120); });
  });
  // UpCart re-renders its body; put the card back when it does (render() returns early once it is in place)
  var tries = 0;
  (function watch() {
    var r = root();
    if (r && window.MutationObserver) { new MutationObserver(soon).observe(r, { childList: true, subtree: true }); return; }
    if (++tries < 40) setTimeout(watch, 500);
  })();
  refresh();
})();
